import { render, staticRenderFns } from "./FixedBottomLeftArea.vue?vue&type=template&id=2d43c900&scoped=true&"
import script from "./FixedBottomLeftArea.vue?vue&type=script&lang=js&"
export * from "./FixedBottomLeftArea.vue?vue&type=script&lang=js&"
import style0 from "./FixedBottomLeftArea.vue?vue&type=style&index=0&id=2d43c900&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2d43c900",
  null
  
)

export default component.exports